const getDeductibleValueFromId = (id) => {
  const idParts = id.split('/');
  return +idParts[0];
};

export const getDeductibleOptions = (options, state, currentDeductible, minimumDeductible) => {
  if (state === 'MD') {
    return options;
  }

  const currentValue = currentDeductible ? getDeductibleValueFromId(currentDeductible) : null;
  const minimum = currentValue && currentValue < minimumDeductible ? currentValue : minimumDeductible;

  return options.map((option) => {
    const value = getDeductibleValueFromId(option.id);
    return {
      ...option,
      disabled: +value < minimum || option.disabled
    };
  });
};

function parseErrorMetadata(error) {
  try {
    return JSON.parse(error.data);
  } catch (e) {
    console.log('error parsing error metadata', e);
    return null;
  }
}

const getCarNotificationFromErrorsAndRejections = (car, errorsAndRejections) => {
  const errorsAndRejectionsAndParsedMetadata = errorsAndRejections?.map((e) => ({
    ...e,
    data: parseErrorMetadata(e) || e.data
  }));

  if (
    errorsAndRejectionsAndParsedMetadata.some(
      (e) =>
        e?.data?.VINs?.includes(car.VIN) ||
        e?.data?.cars?.some(
          (carErrorMetadata) =>
            typeof carErrorMetadata === 'string' &&
            carErrorMetadata.includes(car.make) &&
            carErrorMetadata.includes(car.model) &&
            carErrorMetadata.includes(car.year)
        )
    )
  ) {
    return `This vehicle is ineligible due to Branch's underwriting rules, see rejection information for more details`;
  }

  return null;
};

export const getCarNotification = (car, errorsAndRejections, routesContext) => {
  const { inOfferEditRoute } = routesContext;

  const rejectionNotification = getCarNotificationFromErrorsAndRejections(car, errorsAndRejections);
  if (rejectionNotification) {
    return rejectionNotification;
  }
  if (car.hasOutstandingRecall) {
    return 'This make/model has an outstanding recall. We require proof within 15 days that this has been resolved to keep this vehicle on the policy.';
  }
  if (inOfferEditRoute && car.VIN?.endsWith('111111')) {
    return `This vehicle needs to be replaced with the vehicle's real VIN. If you have the real VIN, remove this vehicle and add it back with the real VIN to continue to checkout`;
  }
};
